/* eslint @typescript-eslint/no-explicit-any: 0 */
import {Dispatch, useState} from 'react';
import {Box, Grid, Button, makeStyles, Modal, CircularProgress} from '@material-ui/core';
import {FolderOutlined} from '@material-ui/icons';

interface EFTDocumentFormProps {
    index: number;
    value: any;
    setDocusignModalRequirement: Dispatch<any>;
    updateRequirements: Dispatch<any>;
    updateSingleRequirement: Dispatch<any>;
}

interface DocusignModalProps {
    onClick: Dispatch<any>;
    showModal: boolean;
    handleDocusignModal: Dispatch<any>;
}

function getModalStyle() {
    const top = 50;
    const left = 50;

    return {
        top: `${top}%`,
        left: `${left}%`,
        transform: `translate(-${top}%, -${left}%)`,
    };
}

const useStyles = makeStyles((theme) => ({
    paper: {
        position: 'absolute',
        width: 400,
        backgroundColor: theme.palette.background.paper,
        padding: theme.spacing(2, 4, 3),
        borderRadius: 5,
    },
}));

function DocusignModal(props: DocusignModalProps) {
    const {onClick, showModal, handleDocusignModal} = props;
    const classes = useStyles();
    const [modalStyle] = useState(getModalStyle);
    const [loading, setLoading] = useState(false);

    return (
        <Modal
            open={showModal}
            onClose={() => {
                handleDocusignModal(false);
            }}
            aria-labelledby="modal-modal-title"
            aria-describedby="modal-modal-description"
        >
            <div style={modalStyle} className={classes.paper}>
                <h4 id="modal-modal-title">Save + Launch Docusign</h4>
                <p id="modal-modal-description" className="modal-text">
                    Let&apos;s continue adding this document in Docusign. This action will save all changes made to this
                    page.
                </p>
                <br />
                <Grid container spacing={1} direction="row" alignItems="center">
                    <Grid item xs={6}>
                        <Button
                            id="save_and_continue_button"
                            className="modal-button"
                            style={{backgroundColor: '#3B58B8', color: 'white'}}
                            variant="outlined"
                            color="primary"
                            onClick={() => {
                                setLoading(true);
                                onClick(setLoading);
                            }}
                        >
                            {!loading ? (
                                <>Save and Continue</>
                            ) : (
                                <CircularProgress size={20} style={{color: 'white'}} />
                            )}
                        </Button>
                    </Grid>
                    <Grid item xs={6}>
                        <Button
                            id="cancel_button"
                            className="modal-button"
                            variant="outlined"
                            color="primary"
                            onClick={() => {
                                handleDocusignModal(false);
                            }}
                        >
                            Cancel
                        </Button>
                    </Grid>
                </Grid>
            </div>
        </Modal>
    );
}

function EFTDocumentForm(props: EFTDocumentFormProps) {
    const {index, value, setDocusignModalRequirement, updateRequirements, updateSingleRequirement} = props;
    const [showModal, setShowModal] = useState(false);
    const [loading, setLoading] = useState(false);
    const handleDocusignModal = (show: boolean) => {
        setShowModal(show);
    };

    return (
        <>
            <Box>
                <Grid container spacing={3} xs={12}>
                    <Grid item xs={12}>
                        <Grid container spacing={1} direction="row" alignItems="center">
                            <Grid item>
                                <FolderOutlined fontSize="small" />
                            </Grid>
                            <Grid item>
                                <h4>EFT Document</h4>
                            </Grid>
                        </Grid>
                    </Grid>
                    <Grid item xs={12}>
                        <Grid container spacing={1} direction="row" alignItems="center">
                            <Grid item xs={3}>
                                {value.data_json && JSON.parse(value.data_json)?.envelopeId ? (
                                    <Button
                                        id={`doc_button_${index}`}
                                        variant="outlined"
                                        color="primary"
                                        onClick={() => {
                                            setLoading(true);
                                            updateSingleRequirement(setLoading);
                                        }}
                                    >
                                        {!loading ? <>Save Requirement</> : <CircularProgress size={30} />}
                                    </Button>
                                ) : (
                                    <Button
                                        id={`doc_button_${index}`}
                                        variant="outlined"
                                        color="primary"
                                        onClick={() => {
                                            setDocusignModalRequirement(value);
                                            handleDocusignModal(true);
                                        }}
                                    >
                                        Save + Launch Docusign
                                    </Button>
                                )}
                            </Grid>
                        </Grid>
                    </Grid>
                </Grid>
            </Box>
            <DocusignModal
                onClick={updateRequirements}
                showModal={showModal}
                handleDocusignModal={handleDocusignModal}
            />
        </>
    );
}

export default EFTDocumentForm;
